export default {
    criteriaList: (_state, _getters, rootState) => {
        const behavioral = rootState.data.settings.sociodemo.behavioral ? rootState.data.behavioral.collection : {}
        const geography = rootState.data.settings.sociodemo.geography ? rootState.data.geography.collection : {}
        const demographic = rootState.data.settings.sociodemo.demographic ? rootState.data.demographic.collection : {}

        const technology = rootState.data.settings.sociodemo.technology
            ? {
                ...rootState.data.browser.collection,
                ...rootState.data.device.collection,
                ...rootState.data.os.collection,
                ...rootState.data.isp.collection
            }
            : {}
        const main = Object.values({
            ...rootState.data.customTaxonomies.collection,
            ...rootState.data.taxonomies.collection,
            ...rootState.data.secondParty.collection,
            ...behavioral,
            ...demographic,
            ...rootState.data.georadar.collection,
            ...geography,
            ...rootState.data.audience.collection,
            ...technology,
            ...rootState.data.media.collection
        })
        return main
    },

    criteriaListWithoutCustomTaxonomies(_state, _getters, rootState) {
        const behavioral = rootState.data.settings.sociodemo.behavioral ? rootState.data.behavioral.collection : {}
        const geography = rootState.data.settings.sociodemo.geography ? rootState.data.geography.collection : {}
        const demographic = rootState.data.settings.sociodemo.demographic ? rootState.data.demographic.collection : {}

        const technology = rootState.data.settings.sociodemo.technology
            ? {
                ...rootState.data.browser.collection,
                ...rootState.data.device.collection,
                ...rootState.data.os.collection,
                ...rootState.data.isp.collection
            }
            : {}
        const main = Object.values({
            ...rootState.data.taxonomies.collection,
            ...rootState.data.secondParty.collection,
            ...behavioral,
            ...demographic,
            ...rootState.data.georadar.collection,
            ...geography,
            ...rootState.data.audience.collection,
            ...technology,
            ...rootState.data.media.collection
        })
        return main
    },

    customTaxonomiesTree: (_state, _getters, rootState) => ({
        ...rootState.data.customTaxonomies.tree
    }),

    audienceInEdition: (state, _getters, rootState) => rootState.data.audience.collection[state.audienceInEditionId],

    audienceInEditionFromLegacyList: (_state, getters, rootState) => rootState.data.audience.list.find(aud => aud.id == getters.audienceInEdition.id),

    inEditionMode: state => state.audienceInEditionId != undefined,

    audienceInEditionId: state => state?.audienceInEditionId,
}
